/**
 * Image Preload Lock
 * 
 * Preloads all critical images before render to prevent layout shift.
 * Returns when ALL images are loaded or timeout.
 */
export function preloadImages(urls, timeout = 8000) {
  if (!urls || !urls.length) return Promise.resolve()

  const start = Date.now()

  return Promise.all(
    urls.map(url => new Promise((resolve) => {
      const img = new Image()
      img.onload  = () => resolve(true)
      img.onerror = () => resolve(false)
      img.src = url
    }))
  ).then(results => {
    const loaded = results.filter(Boolean).length
    const elapsed = Date.now() - start
    if (loaded < results.length) {
      console.warn(`[sync] image preload: ${loaded}/${results.length} (${elapsed}ms)`)
    }
    return { loaded, total: results.length, elapsed }
  })
}

/**
 * Preload images in parallel with concurrency limit
 */
export function preloadImagesBatched(urls, concurrency = 6, timeout = 10000) {
  return new Promise((resolve) => {
    let loaded = 0
    let idx = 0
    const total = urls.length
    if (total === 0) return resolve({ loaded: 0, total: 0 })

    const timer = setTimeout(() => resolve({ loaded, total, timedOut: true }), timeout)

    function loadNext() {
      if (idx >= total) {
        if (loaded >= total) clearTimeout(timer)
        return
      }
      const i = idx++
      const img = new Image()
      img.onload = img.onerror = () => {
        loaded++
        if (loaded >= total) {
          clearTimeout(timer)
          resolve({ loaded, total })
        }
        loadNext()
      }
      img.src = urls[i]
    }

    for (let i = 0; i < concurrency; i++) loadNext()
  })
}
